try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { HeadingBlock } from '@design-system/heading-block';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { forwardRef } from 'react';

const PictoItem = forwardRef(({ className, headingBlock, direction = 'vertical', icon, align = 'start', ctaBlock, ctaAlign = 'start', tag: Tag = 'div', }, ref) => (jsxs(Tag, Object.assign({ ref: ref, className: classNames('cds-picto-item', className, `cds-picto-item--${direction}-${align}`, {
        [`cds-picto-item--align-${align}`]: align,
        [`cds-picto-item--${direction}-direction`]: direction,
    }), "data-testid": "cds-picto-item" }, { children: [jsx("div", Object.assign({ className: "cds-picto-item__content" }, { children: jsxs("div", Object.assign({ className: "cds-picto-item__content-inner" }, { children: [jsx(HeadingBlock, Object.assign({}, headingBlock, { align: align })), ctaBlock && jsx(CtaBlock, Object.assign({}, ctaBlock, { align: ctaAlign }))] })) })), icon && (jsx("div", Object.assign({ className: "cds-picto-item__media" }, { children: jsx(Icon, Object.assign({}, icon)) })))] }))));

export { PictoItem };
